import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import '@/assets/css/reset.scss' // global css
import '@/assets/icons'


import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'


import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueAreaLinkage from 'vue-area-linkage';
Vue.use(VueAreaLinkage)

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';

Vue.prototype.$layer = layer(Vue);

import toTry from "@/components/pc/toTry";
Vue.component('to-try', toTry)


import productBanner from "@/components/pc/productBanner";
Vue.component('product-banner', productBanner)


import mtoTry from "@/components/mobile/toTry";
Vue.component('m-to-try', mtoTry)


import mproductBanner from "@/components/mobile/productBanner";
Vue.component('m-product-banner', mproductBanner)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')